<template>
  <div class="tab-container nav nav-pills mb-3 light-border">
    <span class="text-center bg-orange pl-1 text-white controversy-icon">
      <i class="far fa-comment-lines" />
    </span>
    <span class="controversy-text col-6">{{ title }}</span>
    <span :class="'ml-5 badge badges ' + getPeiStatusClass(peiStatus)">
      {{ peiStatus }}
    </span>
    <div class="d-flex mr-2 controversy-button">
      <ActionButton
        variant="success"
        i="fas fa-file-import pr-1"
        @click="click()"
      >
        Entrar
      </ActionButton>
    </div>
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton';

export default {
  name: 'ControversyBanner',
  components: {
    ActionButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    peiStatus: {
      type: String,
      default: 'Cancelado',
    },
  },
  methods: {
    click() {
      this.$emit('click');
    },
    getPeiStatusClass(status) {
      let statusClass = '';
      //ECG:Esto se debe basar en id de estatus de pei
      switch (status) {
        case 'Borrador':
          statusClass = 'badge-erase';
          break;
        case 'Cancelado':
          statusClass = 'badge-cancel';
          break;
        case 'Completado':
          statusClass = 'badge-complete';
          break;
        case 'Completado - Controversia':
          statusClass = "badge-complete";
          break;
        case 'Firmado':
          statusClass = 'badge-signed';
          break;
        case 'Pendiente':
          statusClass = 'badge-pending';
          break;
        case 'Incompleto':
          statusClass = 'badge-incomplete';
          break;
        case 'Completado – Pendiente Fondos':
          statusClass = 'badge-pending';
          break;
        case 'Firmado Parcial - Pendiente de Fondos':
          statusClass = 'badge-partial';
          break;
        case 'Firmado - Controversia':
          statusClass = 'badge-partial';
          break;
        case 'Propuesta de PEI - Rechazada':
          statusClass = 'badge-pending-funds';
          break;
      }

      return statusClass;
    },
  },
};
</script>

<style scoped>
.tab-container {
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  opacity: 1;
  height: 59px;
  font-weight: normal;
  align-items: center;
}
.controversy-button {
  margin-left: auto;
}
.controversy-icon {
  border-radius: 3px;
  width: 55px;
  height: 59px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}
.controversy-text {
  color: #11291b;
  font: Bold 16px/19px Lato;
  margin-left: 20px;
}
.light-border {
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  opacity: 1;
}
/************ CUSTOM BADGES *************/
.badges {
  color: black;
  font-size: 16px;
  width: auto;
  height: 25px;
  line-height: 3px;
  border-radius: 20px;
  padding: 10px;
}
.badge-erase {
  background: #fcc9c8;
  width: 14%;
}
.badge-cancel {
  background: #d5b89a;
  width: 14%;
}
.badge-complete {
  background: #f8ea80;
  width: 14%;
}
.badge-signed {
  background: #a3e5b3;
  width: 14%;
}
.badge-incomplete {
  background: #d5b89a;
  width: 14%;
}
.badge-waiting {
  background: #a7e6dc;
}
.badge-partial {
  background: #a3e5b3;
}
.badge-pending-funds {
  background: #ddb3d7;
}
.badge-pending {
  background: #f8ea80;
  width: 180px;
}
</style>
